if (!customElements.get('recently-viewed')) {
  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      constructor() {
        super();
        this.started = false;
        this.attempts = 0;
        this.observer = null;
      }

      connectedCallback() {
        if (this.started) return;
        this.started = true;

        const productIds = this.getProductIds();
        if (!productIds.length) return;

        if (!('IntersectionObserver' in window)) {
          setTimeout(() => this.load(productIds), 700);
          return;
        }

        // Wait until the section is close to the viewport so the request does not compete with the first paint.
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0] || !entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.observer = null;
            this.load(productIds);
          },
          { rootMargin: this.dataset.rootMargin || '800px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }

      getProductIds() {
        let stored = [];
        try {
          stored = JSON.parse(localStorage.getItem(this.dataset.storageKey) || '[]');
        } catch (error) {
          stored = [];
        }
        if (!Array.isArray(stored)) return [];

        const excluded = (this.dataset.exclude || '').trim();
        const limit = Math.max(1, Number(this.dataset.limit || 8));

        return stored
          .map((id) => String(id).trim())
          .filter((id) => id && id !== excluded)
          .slice(0, limit);
      }

      load(productIds) {
        const query = productIds.map((id) => `id:${id}`).join(' OR ');

        fetch(`${this.dataset.url}&q=${encodeURIComponent(query)}`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(String(response.status));
            return response.text();
          })
          .then((text) => {
            const template = document.createElement('template');
            template.innerHTML = text;

            const incoming = template.content.querySelector('recently-viewed');
            if (!incoming || !incoming.querySelector('[data-product-id]')) return;

            this.sortByRecency(incoming, productIds);
            this.innerHTML = incoming.innerHTML;
          })
          .catch(() => {
            this.attempts += 1;
            if (this.attempts >= 3) return;
            setTimeout(() => this.load(productIds), 250 * this.attempts);
          });
      }

      // Search returns the products in its own order; put the most recently viewed first.
      sortByRecency(root, productIds) {
        const list = root.querySelector('[data-recently-viewed-list]');
        if (!list) return;

        Array.from(list.children)
          .sort((a, b) => productIds.indexOf(a.dataset.productId) - productIds.indexOf(b.dataset.productId))
          .forEach((item) => list.appendChild(item));
      }
    }
  );
}
